module.exports = __webpack_public_path__ + "static/elephantmain-a8146e9706a62573d38b2665e04319cc.jpeg";